import Vue from 'vue'
import { Module, ActionContext } from 'vuex'
import { AIAgentState, RootState } from '../store/state_models'
import { VoiceAIService } from '../services'
import { awaitToJS } from '@/util/await-to-js'
import { company } from './company'

export const aiAgents: Module<AIAgentState, RootState> = {
  namespaced: true,
  state: {
    isAIAgentEnabled: undefined,
  },
  getters: {
    get: (state: AIAgentState) => {
      return state.isAIAgentEnabled
    },
  },
  mutations: {
    set: (state: AIAgentState, payload: boolean) => {
      state.isAIAgentEnabled = payload
    },
  },
  actions: {
    syncAll: async (
      context: ActionContext<AIAgentState, RootState>,
      locationId: string
    ) => {
      if (!locationId) return

      const companyId = company?.state?.company?.id
      if (!companyId) return

      try {
        const [err, response] = await awaitToJS(VoiceAIService.isAIAgentsEnabled(companyId, locationId))
        if (err) {
          return
        }
        context.commit('set', response)
      } catch (err) {
        console.log('err', err)
      }
    },
  },
}
